export default __webpack_public_path__ + "static/media/IMG_9964.f0fe36d5.webp";